import React from 'react'
import PropTypes from 'prop-types'
import Typography from '../../../components/Basics/Typography'
import {
  Action,
  Card,
  Content,
  Highlights,
  Image,
  ImageWrapper,
  Meta,
  Role,
  Summary,
  TechStack,
  TechTag,
  ViewLink,
  Year,
} from './ProjectCard.styles'

const ProjectCard = ({ project, onClick }) => {
  const { highlights, imagePath, name, role, summary, technologies, year } = project
  const visibleHighlights = highlights.slice(0, 2)

  return (
    <Card onClick={onClick} role="button" tabIndex={0} onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        onClick()
      }
    }}>
      {imagePath && (
        <ImageWrapper>
          <Image
            alt={name}
            loading="lazy"
            src={imagePath}
            onError={(e) => {
              console.error('Image failed:', imagePath)
            }}
          />
        </ImageWrapper>
      )}

      <Content>
        <Typography variant="h4">{name}</Typography>

        <Meta>
          <Role>{role}</Role>
          {year && <Year>{year}</Year>}
        </Meta>

        <Summary>{summary}</Summary>

        {visibleHighlights.length > 0 && (
          <Highlights>
            {visibleHighlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </Highlights>
        )}

        {technologies.length > 0 && (
          <TechStack>
            {technologies.slice(0, 5).map((tech) => (
              <TechTag key={tech}>{tech}</TechTag>
            ))}
          </TechStack>
        )}
      </Content>

      <Action>
        <ViewLink>View case study</ViewLink>
      </Action>
    </Card>
  )
}

ProjectCard.propTypes = {
  onClick: PropTypes.func.isRequired,
  project: PropTypes.shape({
    highlights: PropTypes.arrayOf(PropTypes.string),
    imagePath: PropTypes.string,
    name: PropTypes.string.isRequired,
    role: PropTypes.string,
    summary: PropTypes.string,
    technologies: PropTypes.arrayOf(PropTypes.string),
    year: PropTypes.string,
  }).isRequired,
}

export default ProjectCard
